import type { FundFeatureConfig } from '../../../types/insurances/FundFeatureConfig';

export const fund: FundFeatureConfig = {
    overview: {
        details: {
            showVariant: false,
        },
    },
    funds: {
        visible: false,
    },
};
